var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 58,
    viewBox: "0 0 50 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1542_14305)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_1542_14305",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 44,
    height: 52,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 3,
    y: 3,
    width: 44,
    height: 52
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8473 39.3555L25.0444 53.9507V53.9615L25.0056 54L25 53.9944L24.9943 54L24.9556 53.9615V53.9507L10.1527 39.3555C1.94909 31.2669 1.94909 18.1539 10.1527 10.0664C14.2417 6.03479 19.5967 4.01267 24.9556 4.00006V4.00003C24.9704 4.00001 24.9852 4 25 4C25.0148 4 25.0296 4.00001 25.0444 4.00003V4.00006C30.4032 4.01267 35.7583 6.03479 39.8473 10.0664C48.0509 18.1539 48.0509 31.2669 39.8473 39.3555Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.0444 53.9507L24.6933 53.5946L24.5444 53.7415V53.9507H25.0444ZM39.8473 39.3555L39.4962 38.9994L39.8473 39.3555ZM25.0444 53.9615L25.3966 54.3164L25.5444 54.1697V53.9615H25.0444ZM25.0056 54L24.6546 54.3561L25.0069 54.7033L25.3579 54.3549L25.0056 54ZM25 53.9944L25.351 53.6384L24.9999 53.2923L24.6489 53.6384L25 53.9944ZM24.9943 54L24.6421 54.3549L24.9932 54.7034L25.3454 54.356L24.9943 54ZM24.9556 53.9615H24.4556V54.1697L24.6034 54.3164L24.9556 53.9615ZM24.9556 53.9507H25.4556V53.7415L25.3066 53.5946L24.9556 53.9507ZM10.1527 39.3555L10.5038 38.9994L10.1527 39.3555ZM10.1527 10.0664L10.5038 10.4225L10.5038 10.4224L10.1527 10.0664ZM24.9556 4.00006L24.9568 4.50006L25.4556 4.49888V4.00006H24.9556ZM24.9556 4.00003L24.9547 3.50004L24.4556 3.50093V4.00003H24.9556ZM25 4L24.9999 4.5L25.0001 4.5L25 4ZM25.0444 4.00003H25.5444V3.50093L25.0453 3.50004L25.0444 4.00003ZM25.0444 4.00006H24.5444V4.49888L25.0432 4.50006L25.0444 4.00006ZM39.8473 10.0664L39.4962 10.4224L39.4962 10.4225L39.8473 10.0664ZM25.3954 54.3067L40.1983 39.7115L39.4962 38.9994L24.6933 53.5946L25.3954 54.3067ZM24.5444 53.9507V53.9615H25.5444V53.9507H24.5444ZM24.6922 53.6067L24.6534 53.6451L25.3579 54.3549L25.3966 54.3164L24.6922 53.6067ZM25.3567 53.6439L25.351 53.6384L24.649 54.3505L24.6546 54.3561L25.3567 53.6439ZM25.3454 54.356L25.3511 54.3504L24.6489 53.6384L24.6433 53.644L25.3454 54.356ZM24.6034 54.3164L24.6421 54.3549L25.3466 53.6451L25.3078 53.6067L24.6034 54.3164ZM24.4556 53.9507V53.9615H25.4556V53.9507H24.4556ZM25.3066 53.5946L10.5038 38.9994L9.80168 39.7115L24.6046 54.3067L25.3066 53.5946ZM10.5038 38.9994C2.49873 31.1067 2.49876 18.3141 10.5038 10.4225L9.80171 9.71034C1.39942 17.9936 1.39945 31.4272 9.80168 39.7115L10.5038 38.9994ZM10.5038 10.4224C14.4951 6.48717 19.7225 4.51238 24.9568 4.50006L24.9544 3.50006C19.471 3.51297 13.9884 5.58241 9.80168 9.71036L10.5038 10.4224ZM24.4556 4.00003V4.00006H25.4556V4.00003H24.4556ZM25.0001 3.5C24.985 3.5 24.9699 3.50001 24.9547 3.50004L24.9565 4.50003C24.9709 4.50001 24.9854 4.5 24.9999 4.5L25.0001 3.5ZM25.0001 4.5C25.0146 4.5 25.029 4.50001 25.0435 4.50003L25.0453 3.50004C25.0301 3.50001 25.015 3.5 24.9999 3.5L25.0001 4.5ZM24.5444 4.00003V4.00006H25.5444V4.00003H24.5444ZM40.1983 9.71036C36.0116 5.58241 30.529 3.51297 25.0456 3.50006L25.0432 4.50006C30.2775 4.51238 35.5049 6.48717 39.4962 10.4224L40.1983 9.71036ZM40.1983 39.7115C48.6005 31.4272 48.6006 17.9936 40.1983 9.71034L39.4962 10.4225C47.5012 18.3141 47.5013 31.1067 39.4962 38.9994L40.1983 39.7115Z",
    fill: "white",
    fillOpacity: 0.757183,
    mask: "url(#path-1-outside-1_1542_14305)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0056 54L25.0444 53.9615V53.9502L39.8468 39.3555C48.0504 31.2669 48.0504 18.1539 39.8468 10.0664C35.7579 6.03491 30.4031 4.01279 25.0444 4.00006V4.00003C25.0295 4.00001 25.0146 4 24.9998 4C24.9849 4 24.97 4.00001 24.9551 4.00003V4.00006C19.5964 4.01279 14.2416 6.03491 10.1527 10.0664C1.94909 18.1539 1.94909 31.2669 10.1527 39.3555L24.9551 53.9502V53.9615L24.9939 54L24.9998 53.9942L25.0056 54Z",
    fill: "#0D6AFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.2216,
    cy: 25.0526,
    rx: 7.95797,
    ry: 7.89474,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1542_14305",
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 57.2034,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1542_14305"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1542_14305",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinActive);
export default __webpack_public_path__ + "static/media/pin_active.4dd84d8ded51dfc9b81b0d37756758e9.svg";
export { ForwardRef as ReactComponent };